// ── CONSENT DOCUMENT VERSIONS ────────────────────────────────────────────────
// Single source for the T&Cs / Privacy Policy version and the PDF paths built
// from it. TWO constants, not one: the documents are legally independent and
// version separately. Collapsing them means a T&Cs revision also renames the
// Privacy Policy link to a file that was never written — a 404 on the
// registration screen, and a consent record naming a document nobody wrote.
//
// KEEP IN SYNC with TERMS_VERSION / PRIVACY_VERSION in the server repo's
// server.js. This app cannot import from that repo — separate build, separate
// Railway service — so the value lives in both. Deliberately NOT a
// REACT_APP_* environment variable: these are SHIFTon's own documents,
// identical in every client environment, so the value must not be able to
// differ per deployment. Same rule as the hardcoded POPIA Responsible Party
// line in AuthPage.js.
//
// The version is IN the filename on purpose. Unversioned names meant dropping
// a revised PDF over the old one silently rewrote the document that every past
// consent record points at. Old PDFs are never deleted or overwritten.
//
// Revising a document: see the vault note "Revising Legal Documents". The new
// PDF must be LIVE in public/ before either constant changes.
export const TERMS_VERSION = 'v1.2';
export const PRIVACY_VERSION = 'v1.2';

export const TERMS_PDF = `/terms-and-conditions-${TERMS_VERSION}.pdf`;
export const PRIVACY_PDF = `/privacy-policy-${PRIVACY_VERSION}.pdf`;
